<script>

import { createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();
export var jouet;
var id = jouet.id

function remove() {
    dispatch('remove',  {jouet : jouet} );
}



    
    
</script>


<div class="toy">
    
    {#if jouet.vendu}
    <div class="title">{jouet.name} <span style="color:greenyellow;">(vendu)</span></div>
    {:else}
    <div class="title">{jouet.name}</div>
    {/if}
    <div class="desc">{jouet.descriptif}</div>
    <div class="desc" style="color:#999">Catégorie : {jouet.categorie}<br>Sous catégorie : {jouet.sub_categorie}</div>
    <div class="fin">
        <div class="prix">{jouet.prix.toFixed(2)}€</div>
        <div >Propriétaire : <br>{jouet.owner_name}</div>
    </div>
    {#if !jouet.vendu}
    <div class="del"><button on:click={remove} >🗑️</button></div>
    {/if}
    
    
</div>

<style>
    .toy{
        width: 15vw;
        min-height: 35vh;
        background-color: #262626;
        box-shadow:  5px 5px 10px #151515,
         -5px -5px 10px #373737;
        margin-left: 1vw;
        margin-right: 1vw;
        margin-top: 5vh;
        margin-bottom: 5vh;
        border-radius: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        position: relative;
    }
    .title{
        font-family: 'Poppins', sans-serif;
        font-weight: 700;
        font-size: 1.5rem;
        margin-top: 2vh;
    }
    .desc{
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        font-size: 1rem;
        padding-left: 10px;
        align-self: flex-start;
        margin-top: 3vh;
    }
    .fin{
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        width: 100%;
        align-items: center;
        position: absolute;
        bottom :0;
        height: 20%;
    }
    .prix{
        font-family: 'Poppins', sans-serif;
        font-weight: 700;
        font-size: 1.5rem;
    }
    button{
        font-size: 1.5rem;
        background-color: transparent;
        border-radius: 50%;
        border: none;
        box-shadow:  9px 9px 18px #111111,
             -9px -9px 18px #3b3b3b;
        margin: 10px;
    }
</style>